import {Fragment, useState} from "react";
import TopNavigation from "../components/TopNavigation/TopNavigation";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import {useSelector} from "react-redux";
import cogoToast from "cogo-toast";
import RestClient from "../RestAPI/RestClient";
import AppUrl from "../RestAPI/AppUrl";
import Report from "../components/Report/Report";
import CoEfficientReport from "../components/UnitProfile/CoEfficientReport";
import BricksReport from "../components/Bricks/BricksReport";
import Refund from "../components/Refund/Refund";
import VdsReport from "../components/VDS/VdsReport";
import FloorSpaceReport from "../components/FloorSpace/FloorSpaceReport";
import UnRegisteredBin from "../components/UnRegisteredBin/UnRegisteredBin";
import CoEfficientEntry from "../components/UnitProfile/CoEfficientEntry";
import AuditReport from "../components/Audit/AuditReport";
import Juwellery from "../components/Juwellery/Juwellery";
import Efd from "../components/EFD/Efd";
import DebtReport from "../components/Debt/DebtReport";
import RevenueReport from "../components/Report/RevenueReport";
import MapReport from "../components/Report/MapReport";
import TextEditor from "../components/Report/TextEditor";
import PendingTask from "../components/Report/PendingTask";
import PendingVisit from "../components/Report/PendingVisit";
import CallReport from "../components/Report/CallReport";
import NegativeReport from "../components/Report/NegativeReport";
export default function UnitProfilePage(){
    let state=useSelector((state)=> state);
    const[BinName,setBinName]=useState("No Name found");
    const[BtnSearch,setBtnSearch]=useState("primary");

    const[AllData,setAllData]=useState([{}]);

    const getBinName=()=>{
        const BinNameIndex=document.getElementById("cmbBinNameUnit");
        const BinNameValue=BinNameIndex.options[BinNameIndex.selectedIndex].text;


        let jsonObject={"sql":"Select *  from IVAS_BIN where Name='"+BinNameValue+"' "}
        setBtnSearch("secondary")
        setAllData([{}])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(result=>{
            if(result==""){cogoToast.error("Data not found");setBinName([]);setBtnSearch("primary")}else {
                        cogoToast.success("Data found");setBtnSearch("primary")
                setBinName(result[0]["Name"])

                setAllData(result)

            }
        }).catch(error=>{
            setBtnSearch("primary")
        });
    }

    return(
        <Fragment>
            <TopNavigation/>
            <div className="purchaseDiv text-center mergin_top">
                <Tabs
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-"
                    className="mb-3"
                >
                    <Tab eventKey="BIN" title="BIN">
                       <Report/>
                    </Tab>

                    <Tab eventKey="4.3-Entry" title="4.3 Entry">
                        <CoEfficientEntry/>
                    </Tab>
                    <Tab eventKey="4.3-Report" title="4.3 Report">
                        <CoEfficientReport/>
                    </Tab>


                    <Tab eventKey="Negative" title="Negative">
                        <NegativeReport/>
                    </Tab>

                    <Tab eventKey="audit" title="Audit">
                        <AuditReport/>
                    </Tab>
                    <Tab eventKey="debt" title="Debt">
                        <DebtReport/>
                    </Tab>
                    <Tab eventKey="juwellery" title="Juwellery">
                        <Juwellery/>
                    </Tab>

                    <Tab eventKey="Unregistered" title="Unregistered BIN">
                        <UnRegisteredBin/>
                    </Tab>

                    <Tab eventKey="revenue" title="Revenue">
                        <RevenueReport/>
                    </Tab>
                    <Tab eventKey="map" title="MAP">
                        <MapReport/>
                    </Tab>
                    <Tab eventKey="pending" title="Task">
                        <PendingTask/>
                    </Tab>

                    <Tab eventKey="pendingVisit" title="Visit">
                        <PendingVisit/>
                    </Tab>
                    <Tab eventKey="call" title="Call">
                        <CallReport/>
                    </Tab>
                </Tabs>


            </div>
        </Fragment>
    )
}
